<div>
  <mat-icon svgIcon="empty" color="primary" [matTooltip]="text" class="empty-list-icon"/>
</div>
